
interface IconProps {
  className?: string;

}
export default function CloseIcon({className}:IconProps) {
  return (
    <svg
      viewBox="0 0 32 32"
      className={className} // dimensioni più grandi
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      fill="none"
    >
   
      {/* X più grande */}
      <path
   
        d="M24 24L16 16M16 16L8 24M16 16L24 8M16 16L8 8"

        strokeWidth="2" // più spessa
        strokeLinecap="round"
      />
    </svg>
  )
}
